import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
    setup () {
        return { v$: useVuelidate() }
    },
    delimiters: ['{(', ')}'],
    props: ['steps'],
    data() {
        return {
            count: 0,
            currentStepId: 0,
        }
    },
    validations () {
        return {
            currentStep: {
                value: {
                    required
                }
            }
        }
    },
    computed: {
        currentStep() {
            return this.steps[this.currentStepId]
        },
        progressStyle() {
            return `--quiz-progress: ${(this.currentStepId+1)/(this.steps.length+1)}`;
        }
    },
    mounted() {
        this.goToStep(0)
        // console.log(this);
    },
    updated() {
        // console.log(this);
    },
    methods: {
        goToStep(index) {
            // console.log('goToStep', index);
            this.currentStepId = index
        },

        goToNextStep() {
            if(this.currentStepId != this.steps.length-1)
                this.goToStep(this.currentStepId+1)
            else {
                this.submit()
            }
        },

        goToPrevStep() {
            if(this.currentStepId != 0)
                this.goToStep(this.currentStepId-1)
            else {
                this.$emit('back')
            }
        },

        submit() {
            // that.call('goTo', { url: '/' }, 'Load')
            this.$emit('submit', this.steps)
        }
    }
}
